module.exports = __webpack_public_path__ + "static/media/aland-islands.e22c9be3.png";